export const API_URL = process.env.REACT_APP_API_URL;
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
export const JIRA_BASE_URL = process.env.REACT_APP_JIRA_URL;
export const STATIC_CLIENT_API = process.env.REACT_APP_CLIENT_API_URL;
export const PAYLOAD_API = process.env.REACT_APP_PAYLOAD_API_URL;
export const PERFORMANCE_API = process.env.REACT_APP_PERFORMANCE_API_URL;
export const CURRENT_ENV = process.env.REACT_APP_ENV;
export const PROGRAMMATIC_API_URL = process.env.REACT_APP_PROGRAMMATIC_API_URL;
export const LS_SERVICES_URL = process.env.REACT_APP_LS_SERVICES_URL;
export const SSO_URL = process.env.REACT_APP_SSO_URL;
export const APP_KEY = process.env.REACT_APP_APP_KEY;
